import React from 'react'
export default()=>(
    <style js="true">{
        `

        /* section 3  starts here*/

        .box-icon1 {
            background: #f37f00;
            width:80px;
        }
        .box-icon1-img{
            padding:10px;
            padding-left: 23px;
        }
        .box-icon2-img{
            padding:10px;
            padding-left: 26px;
        }
        .box-icon3-img{
            padding:10px;
            padding-left: 20px;
        }
        .box-icon4-img{
            padding:10px;
            padding-left: 23px;
        }


        .pad{
            background:#ffffff;
            border-bottom: 1px solid #c0c0c0;
                
        }
        // i.fa {
        //     color: #fff;
        //     font-size: 32px;
        // }
        .span {
            background-color: #f37f00;
            padding: 30px 35px;
            display: inline-block;
            margin: 0 10px 0 0;
        }
        .paragraph-section3{
            color: #2e3030;
            font-size: 18px;
            // font-weight: 500;
        }
        .paragraph-section3 p{
            padding-top: 7%;
            color: #438fac;
        }
        .margin-left {
            margin-left: 105px!important;
        }
        
        .progress-bar {
            border-right: solid 5px #FFF;
            
        }
        .progress-bar:last-child {
            border: none; 
        
        }
        .bar{
            background-color: #8a1082!important;
            
        }
        .bars{
            background-color: #dcdcdc!important;
        }
        
            /* section 3 ends here */
        /* ----------------------------------- */

        `
    }

    </style>
);